import { useState, useEffect } from 'react'
import { Row, Col, Form, Table, Card, Badge, Button } from 'react-bootstrap'
import {
  FaGraduationCap,
  FaClipboardCheck,
  FaUser,
  FaEnvelope,
  FaStar,
  FaDownload,
} from 'react-icons/fa'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import TmsHeader from '../TmsComponents/TmsHeader'
import TmsSidebar from '../TmsComponents/TmsSidebar'

const TmsResult = () => {
  // Existing state variables
  const [trainings, setTrainings] = useState([])
  const [quizzes, setQuizzes] = useState([])
  const [search, setSearch] = useState('')
  const [filteredParticipants, setFilteredParticipants] = useState([])
  const [selectedTraining, setSelectedTraining] = useState('')
  const [selectedQuiz, setSelectedQuiz] = useState('')
  const [participants, setParticipants] = useState([])
  const [showResults, setShowResults] = useState(false)
  const { quiz_id } = useParams()

  // Fetch data logic (unchanged)
  useEffect(() => {
    const URL = 'https://kaasbackend.vetrinahealthcare.com/'
    const fetchTrainings = async () => {
      const token = localStorage.getItem('jwttoken')
      try {
        const response = await axios.get(`${URL}tms/training/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        setTrainings([...response.data.trainings])
      } catch (error) {
        console.error('Error fetching training list:', error)
      }
    }
    fetchTrainings()
  }, [])

  useEffect(() => {
    const fetchQuizzes = async () => {
      const URL = 'https://kaasbackend.vetrinahealthcare.com/'
      const training_id = parseInt(selectedTraining)
      try {
        const token = localStorage.getItem('jwttoken')
        const response = await axios.get(
          `${URL}tms/training/${training_id}/quizzes/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        setQuizzes([...response.data])
      } catch (error) {
        console.error('Error fetching quiz list:', error)
      }
    }

    fetchQuizzes()

    if (selectedTraining && selectedQuiz) {
      fetchResults()
    } else {
      setShowResults(false)
    }
  }, [selectedTraining, selectedQuiz])

  const fetchResults = async () => {
    try {
      const token = localStorage.getItem('jwttoken')
      const response = await axios.get(
        `https://kaasbackend.vetrinahealthcare.com/tms/quiz/${selectedQuiz}/results`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      const data = response.data
      setParticipants(data)
      setFilteredParticipants(data)
      setShowResults(true)
    } catch (error) {
      console.error('Error fetching results:', error)
      setParticipants([])
    }
  }

  const getScoreColor = (score) => {
    if (score >= 90) return 'success'
    if (score >= 70) return 'warning'
    return 'danger'
  }

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase()
    setSearch(value)

    const filtered = participants.filter(
      (participant) =>
        participant.name.toLowerCase().includes(value) ||
        participant.email.toLowerCase().includes(value) ||
        participant.score.toString().toLowerCase().includes(value)
    )
    setFilteredParticipants(filtered)
  }

  // Helper function to convert data to CSV
  const downloadResults = () => {
    const headers = ['Name', 'Email', 'Score']
    const csvContent = [
      headers.join(','), // Add headers
      ...participants.map((p) => [p.name, p.email, p.score].join(',')), // Add rows
    ].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute(
      'download',
      `results_training_${selectedTraining}_quiz_${selectedQuiz}.csv`
    )
    link.click()
  }

  return (
    <div className='m-0 w-100'>
      <div
        style={{
          display: 'flex',
          minHeight: '100vh',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        <TmsSidebar />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <TmsHeader />
          <style jsx global>{`
            .fade-in {
              opacity: 0;
              transition: opacity 0.5s ease-in-out;
            }
            .fade-in.visible {
              opacity: 1;
            }
            .selection-card {
              transition: all 0.3s ease-in-out;
            }
            .selection-card:hover {
              transform: translateY(-5px);
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            }
            .table-hover tbody tr:hover {
              background-color: rgba(0, 123, 255, 0.1);
            }
            .score-badge {
              transition: all 0.3s ease-in-out;
            }
            .score-badge:hover {
              transform: scale(1.1);
            }
          `}</style>

          <Card className='shadow-lg border-0'>
            <Card.Body className='p-5'>
              <Card.Title as='h1' className='text-center mb-5 text-primary'>
                RESULT
              </Card.Title>
              <Row className='mb-4 gx-5'>
                <Col md={6}>
                  <Card className='h-100 shadow-sm selection-card'>
                    <Card.Body>
                      <Card.Title className='d-flex align-items-center mb-3'>
                        <FaGraduationCap className='me-2 text-primary' />
                        Select Training
                      </Card.Title>
                      <Form.Select
                        value={selectedTraining}
                        onChange={(e) => setSelectedTraining(e.target.value)}
                        className='form-select-lg'
                      >
                        <option value=''>Choose a training...</option>
                        {trainings.map((training) => (
                          <option
                            key={training.training_id}
                            value={training.training_id}
                          >
                            {training.title}
                          </option>
                        ))}
                      </Form.Select>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className='h-100 shadow-sm selection-card'>
                    <Card.Body>
                      <Card.Title className='d-flex align-items-center mb-3'>
                        <FaClipboardCheck className='me-2 text-primary' />
                        Select Quiz
                      </Card.Title>
                      <Form.Select
                        value={selectedQuiz}
                        onChange={(e) => setSelectedQuiz(e.target.value)}
                        disabled={!selectedTraining}
                        className='form-select-lg'
                      >
                        <option value=''>Choose a quiz...</option>
                        {quizzes.map((quiz) => (
                          <option key={quiz.quiz_id} value={quiz.quiz_id}>
                            {quiz.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <div className={`fade-in ${showResults ? 'visible' : ''}`}>
                {showResults && (
                  <Card className='mt-5 shadow-sm'>
                    <Card.Body>
                      <Card.Title as='h2' className='mb-4 text-primary'>
                        Participant Results
                      </Card.Title>
                      <Row className='mb-4'>
                        <Col md={6}>
                          <Form.Control
                            type='text'
                            placeholder='Search by name or email or score'
                            value={search}
                            onChange={handleSearch}
                          />
                        </Col>
                        <Col md={6} className='text-end'>
                          <Button variant='primary' onClick={downloadResults}>
                            <FaDownload className='me-2' />
                            Download Results
                          </Button>
                        </Col>
                      </Row>
                      <div className='table-responsive'>
                        <Table hover className='align-middle'>
                          <thead>
                            <tr className='bg-light'>
                              <th className='border-0'>
                                <div className='d-flex align-items-center'>
                                  <FaUser className='me-2 text-primary' />
                                  Participant Name
                                </div>
                              </th>
                              <th className='border-0'>
                                <div className='d-flex align-items-center'>
                                  <FaEnvelope className='me-2 text-primary' />
                                  Email ID
                                </div>
                              </th>
                              <th className='text-center border-0'>
                                <div className='d-flex align-items-center justify-content-center'>
                                  <FaStar className='me-2 text-primary' />
                                  Score
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredParticipants.map((participant) => (
                              <tr key={participant.email}>
                                <td>{participant.name}</td>
                                <td>{participant.email}</td>
                                <td className='text-center'>
                                  <Badge
                                    bg={getScoreColor(participant.score)}
                                    className='px-3 py-2 rounded-pill score-badge'
                                  >
                                    {participant.score}
                                  </Badge>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Card.Body>
                  </Card>
                )}
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default TmsResult
